var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXCloseRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "x-close"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Solid",
    d: "M35.855 12.855C36.6035 12.1065 36.6035 10.8929 35.855 10.1444C35.1065 9.39588 33.8929 9.39588 33.1444 10.1444L22.9997 20.2891L12.855 10.1444C12.1065 9.39588 10.8929 9.39588 10.1444 10.1444C9.39588 10.8929 9.39588 12.1065 10.1444 12.855L20.2891 22.9997L10.1444 33.1444C9.39588 33.8929 9.39588 35.1065 10.1444 35.855C10.8929 36.6035 12.1065 36.6035 12.855 35.855L22.9997 25.7103L33.1444 35.855C33.8929 36.6035 35.1065 36.6035 35.855 35.855C36.6035 35.1065 36.6035 33.8929 35.855 33.1444L25.7103 22.9997L35.855 12.855Z",
    fill: "#FF3636"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXCloseRed);
export default __webpack_public_path__ + "static/media/x-close-red.080a4ed6fac8aea2efb749657c30e204.svg";
export { ForwardRef as ReactComponent };